import Vue from 'vue'
import WorldMapVue from 'world-map-vue'

Vue.component('v-world-map', WorldMapVue)
